module.exports = __webpack_public_path__ + "img/diqiu.e815458c.png";